import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconFanBox = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <g>
            <path d="M0.8,6V24h28.4V6H0.8z M27.9,22.7H2.1V8.2L15,21.1L27.9,8.2V22.7z M3.1,7.3h23.9L15,19.2L3.1,7.3z"/>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

IconFanBox.displayName = 'IconFanBox';
IconFanBox.muiName = 'SvgIcon';

export default IconFanBox;



// WEBPACK FOOTER //
// ./src/components/Icons/IconFanBox.js